export class BaseAsset {
    baseAssetId: number;
    name: string;
    description: string;
    assetTypeId: number;
    assetManagementPageId: number;
    fileSize: number;
    mediaFileExtension: string;
    timeStamp: Date;
    coverPage: boolean;
    planeColour: string;
    minScoreToPass: number;
    confirmationPage: boolean;
    resultsPage: boolean;
    questionIndex: number;
    submitted: boolean;
    textSize:number;
}